<template>
<div class="hones-man-wrap" ref="honesWrap">
    <div class="hones-man">
        <Header></Header>
        <div class="hones-scrll">
            <div class="honesGrop" v-for="(item,index ) in UserIndexList" :key="index">
                <div class="item">
                    <div class="item-img">
                        <img :src="item.acater" alt="">
                    </div>
                    <div class="item-info">
                        <HonesDetails :id="item.id"></HonesDetails>
                    </div>
                </div>
            </div>
        </div>
        <Footer></Footer>
    </div>
</div>
</template>

<script>
import BScroll from 'better-scroll';
import Header from '@/components/Header/Header';
import Footer from '@/components/Footer/Footer';
import HonesDetails from '@/components/HonesDetails/HonesDetails';
import _ from 'lodash';
export default {
    name: 'HonestBusinessman',
    components: {
        Header,
        Footer,
        HonesDetails
    },
    data() {
        return {
            UserIndexList: [],
            page: '1',
            pageSize: '8',
            idData: []
        }
    },
    created() {
        this.getUserIndexList()
        setTimeout(() => {
            this.$nextTick(() => {
                this.initScroll()
            })
        }, 500)
    },

    methods: {
        initScroll() {
            this.scroll = new BScroll(this.$refs.honesWrap, {
                scrollY: true,
                click: true,
                probeType: 3,
                pullUpLoad: {
                    threshold: -50, // 在上拉到超过底部 20px 时，触发 pullingUp 事件
                    stop: 20
                },
            })
            this.scroll.on('pullingUp', async (params) => {
                const {
                    page,
                    pageSize
                } = this
                this.page = page + 1;
                await this.getUserIndexList({
                    page: this.page,
                    pageSize
                })
                this.$nextTick(() => {
                    this.scroll.refresh()
                    this.scroll.finishPullUp()
                })
            })
        },
        async getUserIndexList() {
            const result = await this.$http.home.getUserIndexList({
                pageSize: this.pageSize,
                page: this.page
            })
            if (result.code === 200) {
                this.UserIndexList.push(...result.data)
            } else {
                return
            }

        },

    }
}
</script>

<style lang="less">
.hones-man-wrap {
    height: 100vh;
    position: relative;
    overflow: hidden;
    .hones-man {

        .hones-scrll {
            min-height: calc(100vh - 380px);
            margin-top: 10px;

            .honesGrop {
                border-bottom: 0.013333rem dashed #e1e1e1;
                padding: 20px 0;

                .item {
                    height: 200px;
                    display: flex;

                    .item-img {
                        width: 35%;
                        margin-right: 6px;
                        border: 1px solid #e1e1e1;

                        img {
                            width: 100%;
                            object-fit: cover;

                        }

                        p {
                            font-size: 30px;
                            margin-left: 20px
                        }
                    }

                    .item-info {
                        width: 65%;
                    }

                }
            }
        }

    }
}
</style>
